<script setup lang="ts">
import PedidosLiveListado from "./components/PedidosLiveListado.vue";
</script>

<template>
  <PedidosLiveListado />
</template>
